import React,{useEffect} from 'react';
import {
  ContactHero,
  ContactForm,
  ContactInfo,
  ContactFAQ
} from '../../../components/contact';
import CustomerLayout from '../../../layouts/CustomerLayout';

const ContactUs = () => {
  useEffect(()=>{
    window.scroll(0,0);
  },[])
  return (
    <CustomerLayout>
      {/* <ContactHero /> */}
      {/* <ContactForm /> */}
      <ContactInfo />
      <ContactFAQ />
    </CustomerLayout>
  );
};

export default ContactUs;